import {reduceArrayToObject} from './reduceFunctions'

export const shallowObjectCompare = (a) => (b) => {
  return Object.keys(a)
    .reduce((acc, key) => acc && (a[key] === b[key]), true)
};

export const typeMatch = (fns) => (v) => {
  if (Array.isArray(v)) return (fns['onArray'] || ((v) => v))(v);
  else if (typeof v === 'object') return fns.onObject(v);
  else return fns.onPrimitive(v);
};

export const pushClone = (arr) => (data) => {
  let index = arr.findIndex(shallowObjectCompare(data));
  return index === -1 ? arr.concat([data]) : arr.slice(0)
};

export const removeClone = (arr) => (data) => {
  let index = arr.findIndex(shallowObjectCompare(data));
  if (index === -1) {
    let result = arr.slice(0);
    result.splice(index, 1);
    return result
  } else {
    return arr.slice(0)
  }
};

export const cloneObject = (obj) => JSON.parse(JSON.stringify(obj));

export const addKeyClone = (obj) => (id) => (data) => {
  let newEntry = {[id]: data};
  return Object.assign({}, obj, newEntry);
};

export const removeKeyClone = (obj) => (id) => {
  let removedEntry = Object.assign({}, obj);
  delete removedEntry[id];
  return removedEntry
};

let smartAddActions = (id) => (data) => ({
  onArray: (arr) => pushClone(arr)(data),
  onObject: (obj) => addKeyClone(obj)(id)(data),
  onPrimitive: () => data
});

let smartRemoveActions = (id) => (data) => ({
  onArray: (arr) => removeClone(arr)(data),
  onObject: (obj) => removeKeyClone(obj)(id),
  onPrimitive: () => undefined
});

let smartHasActions = (id) => (data) => ({
  onArray: (arr) => !!arr.find(shallowObjectCompare(data)),
  onObject: (obj) => !!obj[id],
  onPrimitive: (v) => v === data
});

export const smartAdd = (v) => (id) => (data) => typeMatch(smartAddActions(id)(data))(v);
export const smartRemove = (v) => (id) => (data) => typeMatch(smartRemoveActions(id)(data))(v);
export const smartHas = (v) => (id) => (data) => typeMatch(smartHasActions(id)(data))(v);

export const getInitial = (firstname, lastname) =>
  firstname && lastname ? firstname.substring(0, 1) + lastname.substring(0, 1) : ' ';

/** Filter Search Term */
export const objFieldLike = (field) => (term) => (obj) =>
  obj[field].toLowerCase().indexOf(term.toLowerCase()) !== -1;

export const deepFilterList = (includeEntireCategories) => (searchfield) => (nestedArrName) => (arr) => (searchterm) => {
  let objLikeSearchTerm = objFieldLike(searchfield)(searchterm);
  let deepFilterSearchTerm = deepFilterList(includeEntireCategories)(searchfield)(nestedArrName);
  return arr.map((i) => {
    let newObj = Object.assign({}, i);
    if (includeEntireCategories && objLikeSearchTerm(newObj)) {
      return newObj
    } else {
      let innerArray = i[nestedArrName];
      let filteredArr = innerArray ? deepFilterSearchTerm(innerArray)(searchterm) : [];
      return innerArray ? Object.assign(newObj, {[nestedArrName]: filteredArr})
        : newObj
    }
  }).filter((i) => (i[nestedArrName] ? i[nestedArrName].length > 0
    : objLikeSearchTerm(i)))
};

/** Seperated Selected Array */
export const deepFind = (subArrName) => (field) => (list) => (elem) => {
  let subArr = list[subArrName];
  return subArr ? deepFind(subArr) : list.find((e) => e[field] === elem[field])
};

export const separateSelectedInList = (selectedObjTemplate) => (subArrName) => (field) => (list) => (selected) => {
  let isFoundInSelected = (typeof selected === 'object') ?
    (e) => selected[e[field]] :
    deepFind(subArrName)(field)(selected);
  return list.reduce((acc, e) => {
    let result = Object.assign({}, e);
    result[subArrName] = result[subArrName].filter((item) => {
      let foundItem = isFoundInSelected(item);
      if (foundItem) {
        acc.selected[subArrName].push(Object.assign({}, item, foundItem));
        return false
      } else {
        return true
      }
    });
    if (result[subArrName].length > 0) {
      acc.unselected.push(result)
    }
    return acc
  }, {unselected: [], selected: Object.assign({}, selectedObjTemplate)})
};

export const newArrayWithObject = (fillElem) => (numElements) => {
  return Array.apply(null, new Array(numElements)).map(() => Object.assign({}, fillElem))
};

/** Mutating operators */
export const clearObjectKeys = (obj) => {
  const keys = Object.keys(obj);
  for (let key of keys) {
    obj[key] = null;
  }
};

export const replaceArrayContents = (oldArr) => (newArr) => {
  oldArr.splice(0, oldArr.length, ...newArr);
};


/** Remap analytics server data */
export const remap = (data) => {
  return data.reduce((acc, v) => {
    let crosssegments = v.crosssegments;
    let crossresult = crosssegments
      ? Object.keys(v.crosssegments).reduce((acc2, v2) => {
        acc2[crosssegments[v2].name] = {
          count: crosssegments[v2].count,
          label: crosssegments[v2].label,
          total: crosssegments[v2].total
        };
        return acc2;
      }, {})
      : {};
    acc[v.name] = {count: v.count, cross: crossresult, label: v.label};
    return acc
  }, {});
};

export const fn_getValueByKey = (val, lookupMap) => {
  return lookupMap[val] !== undefined ? lookupMap[val] : 'N/A!';
};

export const fn_getAttributeWithMap = (attribute) => (_map) => (val) => {
  let map = (typeof _map === 'function' ? _map() : _map);
  return map[val] !== undefined ? map[val][attribute] : 'N/A!'
};

export const fn_getNameWithMap = fn_getAttributeWithMap('name');


//TODO: REFACTOR ME
export const ObjectModelToArrayModel = (obj, conditionsLookupFn) => {
  if (obj === undefined || obj == null || typeof obj !== 'object') return [];
  const keys = Object.keys(obj);
  const conditionsLookup = fn_getNameWithMap(conditionsLookupFn());


  return keys.map((v) => ({
    conditionId: obj[v].conditionId,
    categoryId: obj[v].categoryId,
    name: conditionsLookup(v)
  }));
};

export const injectDisabledProperty = (arr) => {
  return arr.map(item => ({...item,
    $isDisabled: item['hidden'] === undefined ? false : item['hidden']}))
}

export const injectGroupIdToGroupSubitems = (subItemsKey) => (groupIdKey) => (groupIdPropNameToSubItem) => (subitemIdKey) => (subitemIdPropName) => (subitemLabelKey) => (subItemLabelPropName) => (mapFn) => () => {
  const map = cloneObject(mapFn());

  for (let group of map) {
    const subItems = group[subItemsKey];
    group[subItemsKey] = subItems.map((v) =>({
        [groupIdPropNameToSubItem]: group[groupIdKey],
        [subitemIdPropName]: v[subitemIdKey],
        [subItemLabelPropName]: v[subitemLabelKey],
        hidden: v['hidden'] === undefined ? false : v['hidden'],
        $isDisabled: v['hidden'] === undefined ? false : v['hidden']
      })
    );
  }

  return map;
};

export const injectCategoryIdToConditions = (mapFn) => injectGroupIdToGroupSubitems('conditions')('id')('categoryId')('id')('conditionId')('name')('name')(mapFn);

export const smdSelectModelReducer = (acc, v) => {
  acc[v.conditionId] = {
    conditionId: v.conditionId,
    categoryId: v.categoryId,
    others: null
  };

  return acc
};

export const categorizeAOG = (val) => {
  if (val <= 12) {
    return 1;
  } else if (val >= 13 && val <=20) {
    return 2;
  } else if (val >= 21 && val <=27) {
    return 3;
  } else if (val >= 28 && val <=32) {
    return 4;
  } else if (val >= 33 && val <=36) {
    return 5;
  } else if (val >= 37 && val <=41) {
    return 6;
  } else {
    return 7;
  }
};

export const transformObjectModelsToArray = (model) => {
  if (!model) return model;
  let result = Object.assign({}, model);
  let keys = ['morbidities','gynemorbidities','gynecologicalDiagnosis','obstetricHistory','medicalHistory','concomitantProcedure','obProcedure','deliveryIndication','deliveryIndication2'];
  keys.forEach( (key) => {
    if (model[key]) {
      result[key] = Object.values(model[key]);
    }
  });
  return result;
};

export const transformArrayModelsToObject = (model) => {
  let result = Object.assign({}, model);
  let keys = ['morbidities','gynemorbidities','gynecologicalDiagnosis','obstetricHistory','medicalHistory','concomitantProcedure','obProcedure','deliveryIndication','deliveryIndication2'];
  keys.forEach( (key) => {
    if (model[key]) {
      // Handle special case for delivery indications
      result[key] = model[key].reduce(reduceArrayToObject((key === 'deliveryIndication' || key === 'deliveryIndication2')  ? 'id' : 'conditionId'), {});
    }
  });
  return result;
};

